module.exports = __webpack_public_path__ + "media/images/emblems/Maur-blazon-0a275271e1942619105e99eff6ce705d.svg";